import { render, staticRenderFns } from "./MultiSelectBox.vue?vue&type=template&id=61beb037&scoped=true&"
import script from "./MultiSelectBox.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelectBox.vue?vue&type=style&index=0&id=61beb037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61beb037",
  null
  
)

export default component.exports